
import { NgModule } from '@vbrick/angular-ts-decorators';
import { ITemplateCacheService } from 'angular';
import 'angular-sanitize';
import 'ng-infinite-scroll';

import insightTemplate from './insight.html';
import optionRowTemplate from './option-row.html';
import assignedOptionRowTemplate from './assigned-option-row.html';
import { InsightHilightPipe } from './InsightHilightFilter.Pipe';
import { OptionRowDirective } from './OptionRow.Directive';
import { AssignedOptionRowDirective } from './AssignedOptionRow.Directive';
import { InsightDirective } from './Insight.Directive';

@NgModule({
	id: 'vbrick.insight',
	imports: [
		'infinite-scroll',
		'ngSanitize'
	],
	declarations: [
		AssignedOptionRowDirective,
		InsightDirective,
		InsightHilightPipe,
		OptionRowDirective
	]
})
export class InsightModule {
	public static run($templateCache: ITemplateCacheService) {
		'ngInject';
		$templateCache.put('insight.html', insightTemplate);
		$templateCache.put('option-row.html', optionRowTemplate);
		$templateCache.put('assigned-option-row.html', assignedOptionRowTemplate);
	}
}
